<template>
    <PreLoginForm :logo="false" title="">
        <div class="nova-header mb-2">
            <img src="@/assets/img/novakid_logos.png" />
        </div>
        <div class="pre-login-title">{{ $t('SIGNUP_FOR_TRIAL_LESSON') }}</div>
        <LoginTextInput
            :errors="errors"
            label="YOUR_NAME"
            placeholder="PLACEHOLDER_FIRST_NAME"
            autocomplete="given-name"
            name="name"
            v-model.trim="form.name"
        />
        <LoginTextInput
            :errors="errors"
            label="PLACEHOLDER_EMAIL"
            placeholder="PLACEHOLDER_EMAIL_SAMPLE"
            name="email"
            autocomplete="email"
            v-model.trim="form.email"
        />
        <LoginTextInput
            :errors="errors"
            label="PHONE"
            placeholder="300 400 500"
            name="phone"
            autocomplete="phone"
            type="tel"
            v-model.trim="form.phone"
        />
        <div class="login-checkbox">
            <Checkbox
                @input="errors.clear('terms')"
                :color="checkboxColor('terms')"
                v-model="form.terms"
            />
            <div @click="goTo('terms')" class="login-checkbox-text">
                {{ $t('TERMS_NOVAKID') }}
            </div>
        </div>
        <div class="login-checkbox">
            <Checkbox
                @input="errors.clear('privacy')"
                :color="checkboxColor('privacy')"
                v-model="form.privacy"
            />
            <div @click="goTo('privacy')" class="login-checkbox-text">
                {{ $t('PRIVACY_NOVAKID') }}
            </div>
        </div>
        <PreLoginButton
            :label="$t('SIGNUP_YOUR_KID')"
            :loading="loading"
            @click="submit"
            class="login-form-button"
        />
        <transition name="fade">
            <NovakidTerms
                @close="regulationsType = ''"
                v-if="regulationsType"
                :type="regulationsType"
            />
        </transition>
    </PreLoginForm>
</template>
<script>
import LoginTextInput from '@/views/PreLoginView/LoginTextInput.vue'
import PreLoginForm from '@/views/PreLoginView/PreLoginForm'
import PreLoginButton from '@/views/PreLoginView/PreLoginButton'
import NovakidTerms from './NovakidTerms.vue'
export default {
    components: { LoginTextInput, PreLoginForm, PreLoginButton, NovakidTerms },
    data() {
        return {
            loading: false,
            regulationsType: '',
            errors: new this.$Errors(),
            form: {
                name: '',
                phone: '',
                email: '',
                privacy: false,
                terms: false
            }
        }
    },
    methods: {
        checkboxColor(type) {
            return this.errors.has(type) ? 'red' : ''
        },
        goTo(type) {
            this.regulationsType = type
        },
        setPayload() {
            const { name, phone, email } = this.form
            Object.entries(this.form).forEach(([key, val]) => {
                if (!val) {
                    return this.errors.set(key)
                }
                if (key == 'email' && !this.$Utils.validateMail(val)) {
                    !this.$Utils.validateMail(val)
                        ? this.errors.set(key)
                        : this.$query.setQuery({
                              [key]: val.replace('+', '%2B')
                          })
                } else {
                    this.$query.setQuery({ [key]: val })
                }
            })
            return this.errors.errors.length == 0
                ? {
                      name,
                      phone,
                      email,
                      region_code: 'PL',
                      referral_code: 'LIVEKID157595'
                  }
                : false
        },
        goToSchedule() {
            const { query } = this.$route
            this.$router.push({
                params: { step: 'schedule' },
                query
            })
        },
        async submit() {
            try {
                if (this.loading) {
                    return
                }
                const payload = this.setPayload()
                if (!payload) {
                    return
                }
                this.loading = true
                const { id, email, parsed_phone } = await this.$novaApi
                    .post(`trial_requests`, payload)
                    .then(({ data }) => data)
                await this.$query.setQuery({ id, email, phone: parsed_phone })
                this.goToSchedule()
                this.loading = false
            } catch (error) {
                this.loading = false
                this.$Notif.error('TOAST_DOWNLOADING_DATA_FAILED')
            }
        }
    },
    mounted() {
        Object.keys(this.form).forEach(key => {
            const queryVal = this.$route.query[key]
            if (queryVal) {
                this.form[key] = queryVal
            }
        })
    }
}
</script>
